import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.js';
import { AuthProvider } from './auth/AuthProvider.js';
// REQ-FE-034 — load Tailwind v4 entrypoint first (binds tokens.css into
// `@theme {}` utilities), then keep global.css for legacy BEM-classed
// components until per-component ports land.
import './styles/index.css';
import './styles/global.css';

async function enableMocksIfRequested() {
  if (import.meta.env.VITE_USE_MOCKS !== '1') return;
  const { worker } = await import('./mocks/browser.js');
  await worker.start({ onUnhandledRequest: 'bypass' });
}

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, staleTime: 30_000 } },
});

await enableMocksIfRequested();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
